module.exports = __webpack_public_path__ + "img/223.53dae120.png";